var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXcipioMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3170_64983)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3170_64983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "url(#paint0_linear_3170_64983)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#E97B45"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.41 9.5H12C12.55 9.5 13 9.05 13 8.5C13 7.95 12.55 7.5 12 7.5H8C7.45 7.5 7 7.95 7 8.5V12.5C7 13.05 7.45 13.5 8 13.5C8.55 13.5 9 13.05 9 12.5V10.91L12.29 14.2C12.47 14.39 12.72 14.5 13 14.5C13.55 14.5 14 14.05 14 13.5C14 13.22 13.89 12.97 13.71 12.79L10.41 9.5ZM13 16.5C12.72 16.5 12.47 16.61 12.29 16.79L9 20.09V18.5C9 17.95 8.55 17.5 8 17.5C7.45 17.5 7 17.95 7 18.5V22.5C7 23.05 7.45 23.5 8 23.5H12C12.55 23.5 13 23.05 13 22.5C13 21.95 12.55 21.5 12 21.5H10.41L13.7 18.21C13.89 18.03 14 17.78 14 17.5C14 16.95 13.55 16.5 13 16.5ZM22 17.5C21.45 17.5 21 17.95 21 18.5V20.09L17.71 16.8C17.53 16.61 17.28 16.5 17 16.5C16.45 16.5 16 16.95 16 17.5C16 17.78 16.11 18.03 16.29 18.21L19.59 21.5H18C17.45 21.5 17 21.95 17 22.5C17 23.05 17.45 23.5 18 23.5H22C22.55 23.5 23 23.05 23 22.5V18.5C23 17.95 22.55 17.5 22 17.5ZM22 7.5H18C17.45 7.5 17 7.95 17 8.5C17 9.05 17.45 9.5 18 9.5H19.59L16.29 12.79C16.11 12.97 16 13.22 16 13.5C16 14.05 16.45 14.5 17 14.5C17.28 14.5 17.53 14.39 17.71 14.21L21 10.91V12.5C21 13.05 21.45 13.5 22 13.5C22.55 13.5 23 13.05 23 12.5V8.5C23 7.95 22.55 7.5 22 7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3170_64983",
    x: 0,
    y: -0.5,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3170_64983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3170_64983",
    x1: 0,
    y1: 0.5,
    x2: 0,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3170_64983"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcipioMarker);
export default __webpack_public_path__ + "static/media/Xcipio_Marker.63855ebbca6d7baf4d19ff507ea5d506.svg";
export { ForwardRef as ReactComponent };